// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"572":"3b53517f","1257":"3b53517f","2167":"3b53517f","4139":"3b53517f"}[chunkId] + ".chunk.css";
};